module.exports = __webpack_public_path__ + "static/img/jw_logo.3caf371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jw_logo.png
// module id = 6HFH
// module chunks = 38